import { createRouter, createWebHistory } from 'vue-router'
import LeaseItNowFleet from './../apps/LeaseItNowFleet.vue'
import LeaseItNowCar from './../apps/LeaseItNowCar.vue'
import LeaseItNowCompare from './../apps/LeaseItNowCompare.vue'
import LeaseItNowApply from './../apps/LeaseItNowApply.vue'
import { getSegmentWithoutLanguage } from './../../lib/lib'

let segment

try {
  const { configuration } = window['leaseItNowData']
  const { route } = configuration
  segment = getSegmentWithoutLanguage(route.segment)
} catch (error) {
  // console.error(error)
}

const routerLeaseItNow = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/html/Leasing.02.LeaseItNow.html',
      redirect: () => {
        // return {
        //   name: 'compare',
        //   params: {
        //     language: 'el',
        //     slugs:
        //       'hyundai-kona-16i-t-16v-hybrid-premium-plus-dct-89213,tesla-model-3-long-range-awd-88917,fiat-ducato-35-22-mjt-l2h2-92266',
        //   },
        // }
        // return {
        //   name: 'apply',
        //   params: {
        //     language: 'el',
        //     slug: 'hyundai-kona-16i-t-16v-hybrid-premium-plus-dct-89213',
        //     id: '89213',
        //   },
        // }
        // return {
        //   name: 'car',
        //   params: {
        //     language: 'el',
        //     slug: 'citroen-e-berlingo-feel-l1h1-96852',
        //     id: '96852',
        //   },
        // }
        return {
          name: 'home',
          params: { language: 'el' },
          query: {
            searchargs:
              '{"type":"commercial","manufacturers":[{"id":"7","name":"CITROEN"},{"id":"9","name":"FIAT"},{"id":"10","name":"FORD"},{"id":"47","name":"JEEP"}],"models":[],"editions":[],"fuelType":[{"name":100001,"label":"Βενζίνη"}],"bodyType":[],"transmission":"","priceMin":171,"priceMax":1500}',
          },
        }
      },
    },
    {
      path: `/:language/${segment}/:searchargs?`,
      name: 'home',
      component: LeaseItNowFleet,
    },

    {
      path: `/:language/${segment}/compare/:slugs`,
      name: 'compare',
      component: LeaseItNowCompare,
    },

    {
      path: `/:language/${segment}/car/:slug/:id`,
      name: 'car',
      component: LeaseItNowCar,
    },

    {
      path: `/:language/${segment}/apply/:slug/:id`,
      name: 'apply',
      component: LeaseItNowApply,
    },
  ],
})

export default routerLeaseItNow
